import DropdownMenu from '../StockItems/DropdownMenu';

function App(props) {

  var anItem = props.anItem
  var getOrig = props.getOrig;
  var submitGeneric = props.submitGeneric;

  var title;
  if (anItem.n){
    title = anItem.n
  }
  var currAns = getOrig(anItem.i);

  function clickItemInSelect(item, addChangesFn){
    var addChangesOut = [];
    if (addChangesFn){
      addChangesOut = addChangesFn();
    }
    submitGeneric({t:anItem.v, v:item}, anItem.i, addChangesOut);
  }

  return (<td style={{cursor:'pointer'}}>{title}<center>
    <DropdownMenu clickItemInSelect={clickItemInSelect} options={anItem.o} currentAnswer={currAns}/>
     </center></td>)
//
}

//
export default App;
